import { useContext, useMemo } from 'react';
import { BookingDataContext } from '../../../context/bookingDataContext/bookingDataContext';
import { BookingContext } from '../../../context/bookingContext/bookingContext';
import {
  BookingStepValueEnum,
  BookingSubStepValueEnum,
} from '../../BookingWidget/bookingSteps.interface';
import { NotificationContext } from '../../../shared/components/Notification/NotificationContext';
import useFlowSpecificFactory from './useFlowSpecificFactory';

interface UsePolicyPriceDiff {
  priceDiff: number;
}

const usePolicyPriceDiff = (): UsePolicyPriceDiff => {
  const { showNotification } = useContext(NotificationContext);
  const { bookingDataResponse } = useContext(BookingDataContext);
  const { bookingSteps } = useContext(BookingContext);

  const priceDiff = useMemo(() => {
    if (!bookingDataResponse?.bookingData.prevBookingId) {
      return 0;
    }

    if (!bookingDataResponse?.bookingData.totalPaid) {
      showNotification('priceDiffError', 'error', false);
      return 0;
    }
    return +(
      bookingSteps[BookingStepValueEnum.QuotationProposals][
        BookingSubStepValueEnum.TotalPrice
      ] - bookingDataResponse.bookingData.totalPaid
    ).toFixed(2);
  }, [
    bookingDataResponse?.bookingData.totalPaid,
    bookingSteps,
    showNotification,
  ]);

  return {
    priceDiff,
  };
};

export default usePolicyPriceDiff;
